import React from "react";
import type { RangeSearchItem } from "../sp/portalSearchTypes";

type Props = {
  item: RangeSearchItem;
};

function PortalPCRangeField({ item }: Props) {
  return (
    <div className="portalPcRangeControl">
      <select
        className="portalPcSelect"
        aria-label={`${item.title}（下限）`}
        value={item.gte || ""}
        onChange={(e) => item.setGte(e.target.value)}
      >
        <option value="">指定なし</option>
        {item.items.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <span className="portalPcRangeSep">〜</span>
      <select
        className="portalPcSelect"
        aria-label={`${item.title}（上限）`}
        value={item.lte || ""}
        onChange={(e) => item.setLte(e.target.value)}
      >
        <option value="">指定なし</option>
        {item.items.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default PortalPCRangeField;
